import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    sameDescription: {
        id: '_.next_repayment_summary.same_description',
        defaultMessage: 'Your next repayment stays the same'
    },
    reducedDescription: {
        id: '_.next_repayment_summary.reduced_description',
        defaultMessage: 'Compared to your next repayment of {amount}'
    },
    label: {
        id: '_.next_repayment_summary.label',
        defaultMessage: 'Next repayment'
    }
});
